import { gql } from "generated-graphql";

export const GET_STAFF_GENERATOR_STATUS_CHANGES = gql(`
  query StaffGeneratorStatusChanges(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
    $startDate: Date
    $endDate: Date
    $withStats: Boolean
  ) {
    staffGeneratorStatusChanges(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      startDate: $startDate
      endDate: $endDate
      withStats: $withStats
    ) {
      items {
        facilityId
        facilityName
        tenantId
        tenantName
        state
        source
        periodStart
        lastPeriodStart
        mismatchMonths
        mismatchPeriodStarts
        previousPeriodStart
        reportedFederalStatus
        calculatedFederalStatus
        oldFederalStatus
        newFederalStatus
        oldStateStatus
        newStateStatus
        reportedStateStatus
        reportedStateStatusLabel
        calculatedStateStatus
        stateDirection
        changeExplanation
        updatedAt
        direction
        sustainedMonths
        riskLevel
        detectedAt
        detectedAtApproximate
        validatedAt
        staffAssigneeName
        peerReviewerName
        openSubmission {
          id
          title
          status
          dueDate
          assigneeName
        }
        linkedSubmission {
          id
          title
          submissionType
          status
          dueDate
          assigneeName
        }
        manifestCorrectionCount
        resolutionStatus
      }
      count
      stats {
        totalChanges
        facilitiesChanged
        potentialExceedances
        exceedancesToLqg
        exceedancesToSqg
        exceedanceCount
        downwardTrendCount
        awaitingValidation
        readyForPickup
        inFlight
        awaitingCorrection
        resolvedCount
        elevatedRiskCount
        medianDaysToValidation
        p90DaysToValidation
        medianDaysToResolution
        p90DaysToResolution
        oldestOpenDays
        openOver30Days
      }
    }
  }
`);
